import React from 'react';
import { useTranslation } from 'react-i18next';

import { dateFormatter } from '../../utils/dateTime';
import { priceSeparator } from '../../utils/formatter';
import { Button } from '../Button';

import { ICarCard } from './CarCard';
import {
  ButtonIcon,
  DateTimeContainer,
  DateTimeLabel,
  InfoContent,
  InfoLabel,
  OwnerContainer,
  OwnerLabel,
  RowContent,
  StatusLabel,
  Title,
  Wrapper,
} from './CarCardElements';

const CarCard = (props: ICarCard.IProps) => {
  const { t } = useTranslation();
  const { isLoading, item, onClick } = props;

  const owner = () => {
    if (item?.car_detail) {
      if (!item?.car_detail.vehicle_owner) {
        if (item?.car_detail.vehicle_owner_someone_else === 'familyOrFriend') {
          const user = item?.car_detail?.vehicle_owner_family_member_or_friend;
          if (user && user?.first_name && user?.last_name) {
            return user.first_name + ' ' + user.last_name;
          } else {
            return t('user');
          }
        } else {
          return item?.car_detail.vehicle_owner_someone_else;
        }
      } else {
        return item.seller.first_name + ' ' + item.seller.last_name;
      }
    }
  };

  return (
    <Wrapper>
      <Title>{`${item?.model_full_name.make} ${item?.model_full_name.model} ${item?.model_full_name.year}`}</Title>
      <InfoContent>
        {item?.car_detail.mileage ? (
          <InfoLabel>{`${priceSeparator(item?.car_detail.mileage)} ${t(
            'inspection.miles',
          )}`}</InfoLabel>
        ) : (
          <InfoLabel>{t('inspection.no_mileage')}</InfoLabel>
        )}
        {!!item?.car_detail.fuel && <InfoLabel>{item?.car_detail.fuel}</InfoLabel>}
        <InfoLabel>{item?.model_full_name.style}</InfoLabel>
      </InfoContent>
      <DateTimeContainer>
        <DateTimeLabel>
          <span className={'icon-fi_calendar'} />
          {dateFormatter(`${item?.created_at}`, 'date')}
        </DateTimeLabel>
        <DateTimeLabel>
          <span className={'icon-clock'} />
          {dateFormatter(`${item?.created_at}`, 'time')}
        </DateTimeLabel>
      </DateTimeContainer>
      <RowContent>
        <OwnerContainer>
          <OwnerLabel>{owner()?.trim() ? owner() : t('user')}</OwnerLabel>
          <OwnerLabel>{`${t('inspection.cn')}: ${item?.car_number}`}</OwnerLabel>
        </OwnerContainer>
        <StatusLabel status={item?.status}>{item?.status_text}</StatusLabel>
      </RowContent>
      {item?.status !== 9 ? (
        <Button
          label={
            item?.status === 1
              ? t('inspection.start_inspection')
              : t('inspection.continue_inspecting')
          }
          isLoading={isLoading}
          onClick={onClick}
        >
          <ButtonIcon className={'icon-Icons'} />
        </Button>
      ) : (
        <div />
      )}
    </Wrapper>
  );
};

export { CarCard };
